<template>
    <form method="post" action="" v-on:submit="submitForm">
        <div class="form-group">
            <label>Name: *</label><br />
            <input type="text" name="name" v-model="finalData.name" />
        </div>
        <div class="form-group">
            <label>Code: *</label><br />
            <input type="text" name="code" v-model="finalData.code" />
        </div>
        <div class="form-group">
            <label>Sort ID: *</label><br />
            <input type="number" name="sortId" v-model="finalData.sortId" />
        </div>
        <div class="form-group">
            <label>Alert Message:</label><br />
            <input type="text" name="alertMessage" v-model="finalData.alertMessage" />
        </div>
        <div class="form-group">
            <label>Alert Description:</label><br />
            <textarea name="alertDescription" v-model="finalData.alertDescription"></textarea>

        </div>
        <div class="form-group">
            <button type="submit">{{ submitText || 'Submit' }}</button>
        </div>
    </form>
</template>

<script>
export default {
    name: 'SoftwareForm',
    props: ['formData', 'submitText'],
    emits: ['formSubmitted'],
    data: function() {
        return {
            finalData: this.formData ? JSON.parse(JSON.stringify(this.formData)) : {},
        }
    },
    methods: {
        submitForm(e) {
            e.preventDefault()
            this.$emit('formSubmitted', this.finalData)
        }
    }
}
</script>

<style lang="scss" scoped>
.existing-file {
    display: block;
    width: fit-content;
    padding: 2px;
    margin-bottom: 2px;
    border: 1px solid #aaa;
}
</style>
